<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',

  provide () {
    return {
      reload: this.reload
    };
  },

  // directives: {
  //   drag: {
  //     inserted: function (el) {
  //       let odiv = null; let disX; let disY;
  //       el.addEventListener('mousedown', dragDomDown);

  //       function dragDomDown (e) {
  //         odiv = e.currentTarget;
  //         disX = e.clientX - odiv.offsetLeft;
  //         disY = e.clientY - odiv.offsetTop;
  //         document.addEventListener('mousemove', dragDomMove);
  //         document.addEventListener('mouseup', dragDomUp);
  //       }

  //       function dragDomMove (e) {
  //         el.style.pointerEvents = 'none';

  //         let left = e.clientX - disX;
  //         let top = e.clientY - disY;
  //         if (left < 0) {
  //           left = 0;
  //         }
  //         if (top < 0) {
  //           top = 0;
  //         }
  //         if (left >= document.documentElement.clientWidth - odiv.offsetWidth) {
  //           left = document.documentElement.clientWidth - odiv.offsetWidth;
  //         }
  //         if (top >= document.documentElement.clientHeight - odiv.offsetHeight) {
  //           top = document.documentElement.clientHeight - odiv.offsetHeight;
  //         }

  //         odiv.style.left = left + 'px';
  //         odiv.style.top = top + 'px';
  //       }

  //       function dragDomUp (e) {
  //         el.style.pointerEvents = null;
  //         document.removeEventListener('mousemove', dragDomMove);
  //         document.removeEventListener('mouseup', dragDomUp);
  //       }
  //     }
  //   }
  // },

  data () {
    return {
      isRouterAlive: true
    };
  },

  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="scss">
  @import "./assets/icon/iconfont.css";
  @import "./style/var";
  @import "./style/main";
  @import "./style/common";
  #app{
    width: 100%;
    height: 100%;
  }
</style>
